// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderHistoryList-module__font-s-10____V4OR {
  font-size: 10px !important;
}

.OrderHistoryList-module__font-s-12___Ctnko {
  font-size: 12px !important;
}

.OrderHistoryList-module__font-s-13___QY91V {
  font-size: 13px !important;
}

.OrderHistoryList-module__font-s-14___ySb5A {
  font-size: 14px !important;
}

.OrderHistoryList-module__font-s-15___q24rd {
  font-size: 15px !important;
}

.OrderHistoryList-module__font-s-16___qIEKh {
  font-size: 16px !important;
}

.OrderHistoryList-module__font-s-18___PRKGV {
  font-size: 18px !important;
}

.OrderHistoryList-module__font-s-20___CERNW {
  font-size: 20px !important;
}

.OrderHistoryList-module__font-s-22___wHUU8 {
  font-size: 22px !important;
}

.OrderHistoryList-module__font-s-28___YUvfx {
  font-size: 28px !important;
}

.OrderHistoryList-module__font-w-400___yKiT6 {
  font-weight: 400 !important;
}

.OrderHistoryList-module__font-w-500___xYviu {
  font-weight: 500 !important;
}

.OrderHistoryList-module__font-w-600___eU9YX {
  font-weight: 600 !important;
}

.OrderHistoryList-module__font-w-700___cICyX {
  font-weight: 700 !important;
}

.OrderHistoryList-module__p-5___kbfAT {
  padding: 5px !important;
}

.OrderHistoryList-module__p-12___e2psx {
  padding: 12px !important;
}

.OrderHistoryList-module__p-16___tEdss {
  padding: 16px !important;
}

.OrderHistoryList-module__p-30___rPVqF {
  padding: 30px !important;
}

.OrderHistoryList-module__p-b-0___K85rf {
  padding-bottom: 0 !important;
}

.OrderHistoryList-module__p-b-5___dEWCI {
  padding-bottom: 5px !important;
}

.OrderHistoryList-module__p-b-10___z0sn8 {
  padding-bottom: 10px !important;
}

.OrderHistoryList-module__p-b-12___gzuEs {
  padding-bottom: 12px !important;
}

.OrderHistoryList-module__p-b-16____mdo2 {
  padding-bottom: 16px !important;
}

.OrderHistoryList-module__p-b-18___od9Ca {
  padding-bottom: 18px !important;
}

.OrderHistoryList-module__p-b-20___F197E {
  padding-bottom: 20px !important;
}

.OrderHistoryList-module__p-b-25___ncu3T {
  padding-bottom: 25px !important;
}

.OrderHistoryList-module__p-b-30___XFd66 {
  padding-bottom: 30px !important;
}

.OrderHistoryList-module__p-b-50___yGFPm {
  padding-bottom: 50px !important;
}

.OrderHistoryList-module__p-t-0___wa7qU {
  padding-top: 0 !important;
}

.OrderHistoryList-module__p-t-12___Q0K8L {
  padding-top: 12px !important;
}

.OrderHistoryList-module__p-t-16___XXB_O {
  padding-top: 16px !important;
}

.OrderHistoryList-module__p-t-18___J3P9J {
  padding-top: 18px !important;
}

.OrderHistoryList-module__p-t-20___eiINl {
  padding-top: 20px !important;
}

.OrderHistoryList-module__p-t-30___CWSXD {
  padding-top: 30px !important;
}

.OrderHistoryList-module__p-t-40___ttMzU {
  padding-top: 40px !important;
}

.OrderHistoryList-module__p-t-50___o7piS {
  padding-top: 50px !important;
}

.OrderHistoryList-module__p-l-20___oltvs {
  padding-left: 20px !important;
}

.OrderHistoryList-module__p-l-30___IdOIx {
  padding-left: 30px !important;
}

.OrderHistoryList-module__p-l-40___d3rsh {
  padding-left: 40px !important;
}

.OrderHistoryList-module__p-r-16___fDKpr {
  padding-right: 16px !important;
}

.OrderHistoryList-module__p-r-20___BCMFz {
  padding-right: 20px !important;
}

.OrderHistoryList-module__p-r-30___Z7HZ0 {
  padding-right: 30px !important;
}

.OrderHistoryList-module__p-r-50___TB7nb {
  padding-right: 50px !important;
}

.OrderHistoryList-module__p-r-60___ENOPN {
  padding-right: 60px !important;
}

.OrderHistoryList-module__m-b-1___Hz2MG {
  margin-bottom: 1px !important;
}

.OrderHistoryList-module__m-b-2___ECsyt {
  margin-bottom: 2px !important;
}

.OrderHistoryList-module__m-b-6___qIbx4 {
  margin-bottom: 6px !important;
}

.OrderHistoryList-module__m-b-8___ebBcx {
  margin-bottom: 8px !important;
}

.OrderHistoryList-module__m-b-10___N84G7 {
  margin-bottom: 10px !important;
}

.OrderHistoryList-module__m-b-14___meWAq {
  margin-bottom: 14px !important;
}

.OrderHistoryList-module__m-b-16___v439i {
  margin-bottom: 16px !important;
}

.OrderHistoryList-module__m-b-20___nE1x9 {
  margin-bottom: 20px !important;
}

.OrderHistoryList-module__m-b-22___aRqV8 {
  margin-bottom: 22px !important;
}

.OrderHistoryList-module__m-b-24___etHmC {
  margin-bottom: 24px !important;
}

.OrderHistoryList-module__m-b-30___dcFRc {
  margin-bottom: 30px !important;
}

.OrderHistoryList-module__m-b-32___dxCM5 {
  margin-bottom: 32px !important;
}

.OrderHistoryList-module__m-b-40___ecmV2 {
  margin-bottom: 40px !important;
}

.OrderHistoryList-module__m-t-2____CNmt {
  margin-top: 2px !important;
}

.OrderHistoryList-module__m-t-3___VgPQ4 {
  margin-top: 3px !important;
}

.OrderHistoryList-module__m-t-4___ZhokA {
  margin-top: 4px !important;
}

.OrderHistoryList-module__m-t-5___uucsd {
  margin-top: 5px !important;
}

.OrderHistoryList-module__m-t-8___T21v8 {
  margin-top: 8px !important;
}

.OrderHistoryList-module__m-t-10___R7cBm {
  margin-top: 10px !important;
}

.OrderHistoryList-module__m-t-15___VFdN9 {
  margin-top: 15px !important;
}

.OrderHistoryList-module__m-t-16___bT0hb {
  margin-top: 16px !important;
}

.OrderHistoryList-module__m-t-20___f2DAU {
  margin-top: 20px !important;
}

.OrderHistoryList-module__m-t-22___KK8hM {
  margin-top: 22px !important;
}

.OrderHistoryList-module__m-t-30___KWpp9 {
  margin-top: 30px !important;
}

.OrderHistoryList-module__m-t-32___CLhoo {
  margin-top: 32px !important;
}

.OrderHistoryList-module__m-l-auto___sXFuQ {
  margin-left: auto !important;
}

.OrderHistoryList-module__m-l-4____p_PQ {
  margin-left: 4px !important;
}

.OrderHistoryList-module__m-l-5___u3jOM {
  margin-left: 5px !important;
}

.OrderHistoryList-module__m-l-6___W_cD4 {
  margin-left: 6px !important;
}

.OrderHistoryList-module__m-l-8___PlKvn {
  margin-left: 8px !important;
}

.OrderHistoryList-module__m-l-10___K_bcS {
  margin-left: 10px !important;
}

.OrderHistoryList-module__m-l-16___mXLpS {
  margin-left: 16px !important;
}

.OrderHistoryList-module__m-l-20___Q0zZu {
  margin-left: 20px !important;
}

.OrderHistoryList-module__m-l-24___DpMNn {
  margin-left: 24px !important;
}

.OrderHistoryList-module__m-l-30___zH3Vr {
  margin-left: 30px !important;
}

.OrderHistoryList-module__m-l-35___x4XmZ {
  margin-left: 35px !important;
}

.OrderHistoryList-module__m-l-40___scQdm {
  margin-left: 40px !important;
}

.OrderHistoryList-module__m-r-8___KjoaK {
  margin-right: 8px !important;
}

.OrderHistoryList-module__m-r-10___QMF_1 {
  margin-right: 10px !important;
}

.OrderHistoryList-module__m-r-16___dEBOU {
  margin-right: 16px !important;
}

.OrderHistoryList-module__m-r-20___MzYEb {
  margin-right: 20px !important;
}

.OrderHistoryList-module__m-r-24___pWDx1 {
  margin-right: 24px !important;
}

.OrderHistoryList-module__m-r-30____L736 {
  margin-right: 30px !important;
}

.OrderHistoryList-module__m-r-40___j_yxU {
  margin-right: 40px !important;
}

.OrderHistoryList-module__border-r-3___VpdwE {
  border-radius: 3px !important;
}

.OrderHistoryList-module__border-r-4___XI6q7 {
  border-radius: 4px !important;
}

.OrderHistoryList-module__border-r-6___WserW {
  border-radius: 6px !important;
}

.OrderHistoryList-module__border-r-10___xiYcu {
  border-radius: 10px !important;
}

.OrderHistoryList-module__border-r-12___eOY8t {
  border-radius: 12px !important;
}

.OrderHistoryList-module__border-r-16___oNMYt {
  border-radius: 16px !important;
}

.OrderHistoryList-module__border-r-50___amaVS {
  border-radius: 50% !important;
}

.OrderHistoryList-module__primary-border___zQxzH {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.OrderHistoryList-module__primary-border-b___ujkjC {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.OrderHistoryList-module__primary-border-t___jYeck {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.OrderHistoryList-module__primary-border-l___wrBz9 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.OrderHistoryList-module__primary-border-r___SpFnD {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.OrderHistoryList-module__secondary-border___kJ8JO {
  border: 1px solid #637768;
}

.OrderHistoryList-module__secondary-border-b___yodXc {
  border-bottom: 1px solid #637768;
}

.OrderHistoryList-module__secondary-border-t___HZI8P {
  border-top: 1px solid #637768;
}

.OrderHistoryList-module__secondary-border-l___mHpaU {
  border-left: 1px solid #637768;
}

.OrderHistoryList-module__secondary-border-r___RKRk5 {
  border-right: 1px solid #637768;
}

.OrderHistoryList-module__gap-0___RTrfs {
  gap: 0 !important;
}

.OrderHistoryList-module__gap-2___pyB2z {
  gap: 2px !important;
}

.OrderHistoryList-module__gap-4___r3b39 {
  gap: 4px !important;
}

.OrderHistoryList-module__gap-5___Zgz7K {
  gap: 5px !important;
}

.OrderHistoryList-module__gap-6___fUX1J {
  gap: 6px !important;
}

.OrderHistoryList-module__gap-8___Hg0ia {
  gap: 8px !important;
}

.OrderHistoryList-module__gap-10___FHWlK {
  gap: 10px !important;
}

.OrderHistoryList-module__gap-12___HO8rG {
  gap: 12px !important;
}

.OrderHistoryList-module__gap-14___M7s1r {
  gap: 14px !important;
}

.OrderHistoryList-module__gap-16___JMqHW {
  gap: 16px !important;
}

.OrderHistoryList-module__gap-18___XIZf3 {
  gap: 18px !important;
}

.OrderHistoryList-module__gap-20____iQLh {
  gap: 20px !important;
}

.OrderHistoryList-module__gap-24___OG8gK {
  gap: 24px !important;
}

.OrderHistoryList-module__gap-26___BWFEU {
  gap: 26px !important;
}

.OrderHistoryList-module__gap-30___L4fjz {
  gap: 30px !important;
}

.OrderHistoryList-module__gap-32___GES_9 {
  gap: 32px !important;
}

.OrderHistoryList-module__gap-40___wCdik {
  gap: 40px !important;
}

.OrderHistoryList-module__gap-50___Gajpe {
  gap: 50px !important;
}

.OrderHistoryList-module__flex-1___fHdye {
  flex: 1;
}

.OrderHistoryList-module__flex-none___A_bMY {
  flex: none !important;
}

.OrderHistoryList-module__flex-column___Emb2T {
  display: flex;
  flex-direction: column !important;
}

.OrderHistoryList-module__flex-row___D7oca {
  display: flex;
  flex-direction: row !important;
}

.OrderHistoryList-module__vertically-centered___NZU_1 {
  display: flex;
  align-items: center !important;
}

.OrderHistoryList-module__horizontally-centered___V4ReZ {
  display: flex;
  justify-content: center !important;
}

.OrderHistoryList-module__horizontally-end___PuXQE {
  display: flex;
  justify-content: end !important;
}

.OrderHistoryList-module__vertically-start___TSb94 {
  display: flex;
  align-items: start !important;
}

.OrderHistoryList-module__space-between___rGgQx {
  display: flex;
  justify-content: space-between !important;
}

.OrderHistoryList-module__flex-wrap___Cjn7h {
  flex-wrap: wrap !important;
}

.OrderHistoryList-module__height-100___STvar {
  height: 100%;
}

.OrderHistoryList-module__width-50___HEUMd {
  width: 50% !important;
}

.OrderHistoryList-module__width-100___gzYtm {
  width: 100%;
}

.OrderHistoryList-module__cursor-pointer____xbkO {
  cursor: pointer;
}

.OrderHistoryList-module__cursor-not-allowed___RwOMu {
  cursor: not-allowed !important;
}

.OrderHistoryList-module__absolute-centered___oFNup {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.OrderHistoryList-module__absolute___XiYQ6 {
  position: absolute;
}

.OrderHistoryList-module__relative___MP641 {
  position: relative;
}

.OrderHistoryList-module__fixed___zQmug {
  position: fixed;
}

.OrderHistoryList-module__visible___SU9Y5 {
  opacity: 1;
}

.OrderHistoryList-module__invisible___mcfGl {
  opacity: 0;
}

.OrderHistoryList-module__col-90___oDzbr {
  width: 90% !important;
}

.OrderHistoryList-module__col-auto___w3Gg9 {
  width: auto !important;
}

.OrderHistoryList-module__medical-tabs___Dg1cm {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.OrderHistoryList-module__medical-table-new____hTcn {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.OrderHistoryList-module__medical-table-new____hTcn:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.OrderHistoryList-module__medical-table-new____hTcn::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.OrderHistoryList-module__medical-table-new____hTcn::-webkit-scrollbar-track {
  display: none;
}
.OrderHistoryList-module__medical-table-new____hTcn.OrderHistoryList-module__no-pagination___ESHp8 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.OrderHistoryList-module__medical-table-new____hTcn.OrderHistoryList-module__no-pagination___ESHp8:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.OrderHistoryList-module__medical-table-new____hTcn.OrderHistoryList-module__no-pagination___ESHp8::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.OrderHistoryList-module__medical-table-new____hTcn.OrderHistoryList-module__no-pagination___ESHp8::-webkit-scrollbar-track {
  display: none;
}

.OrderHistoryList-module__medical-table-empty___slJsF {
  padding: 14px 40px !important;
}

.OrderHistoryList-module__icon-btn___vHA5A {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.OrderHistoryList-module__search-icon___IBQEJ {
  width: 24px;
  height: 24px;
  align-self: center;
}

.OrderHistoryList-module__disable-select___Pohdo {
  user-select: none;
}

.OrderHistoryList-module__break-word___eLdSA {
  word-break: break-word;
}

.OrderHistoryList-module__popup-clear-btn___xYQ5u {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.OrderHistoryList-module__scroll-m-b-20___SoB0_ {
  scroll-margin-bottom: 20px;
}

.OrderHistoryList-module__empty___Ff6Bb {
  padding: 14px 20px;
  background-color: #f1f3e7;
  border-radius: 12px;
  margin: 22px 40px;
}
.OrderHistoryList-module__empty___Ff6Bb .OrderHistoryList-module__icon___RiqPO {
  width: 22px;
  height: 22px;
}
.OrderHistoryList-module__empty___Ff6Bb .OrderHistoryList-module__text___a9jiv {
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 19px;
  color: #375844;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/fragments/CGMOrdersFragment/components/OrderHistoryList/OrderHistoryList.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;AA8pBF;AA5pBE;EACE,WAAA;EACA,YAAA;AA8pBJ;AA3pBE;EEaA,+BApBO;EAqBP,gBAFmD;EFVjD,iBAAA;EACA,cAAA;AA8pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.empty {\n  padding: 14px 20px;\n  background-color: #f1f3e7;\n  border-radius: 12px;\n  margin: 22px 40px;\n\n  .icon {\n    width: 22px;\n    height: 22px;\n  }\n\n  .text {\n    @include get-font($roboto);\n    line-height: 19px;\n    color: get-color(greenNew, dark);\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `OrderHistoryList-module__font-s-10____V4OR`,
	"fontS12": `OrderHistoryList-module__font-s-12___Ctnko`,
	"fontS13": `OrderHistoryList-module__font-s-13___QY91V`,
	"fontS14": `OrderHistoryList-module__font-s-14___ySb5A`,
	"fontS15": `OrderHistoryList-module__font-s-15___q24rd`,
	"fontS16": `OrderHistoryList-module__font-s-16___qIEKh`,
	"fontS18": `OrderHistoryList-module__font-s-18___PRKGV`,
	"fontS20": `OrderHistoryList-module__font-s-20___CERNW`,
	"fontS22": `OrderHistoryList-module__font-s-22___wHUU8`,
	"fontS28": `OrderHistoryList-module__font-s-28___YUvfx`,
	"fontW400": `OrderHistoryList-module__font-w-400___yKiT6`,
	"fontW500": `OrderHistoryList-module__font-w-500___xYviu`,
	"fontW600": `OrderHistoryList-module__font-w-600___eU9YX`,
	"fontW700": `OrderHistoryList-module__font-w-700___cICyX`,
	"p5": `OrderHistoryList-module__p-5___kbfAT`,
	"p12": `OrderHistoryList-module__p-12___e2psx`,
	"p16": `OrderHistoryList-module__p-16___tEdss`,
	"p30": `OrderHistoryList-module__p-30___rPVqF`,
	"pB0": `OrderHistoryList-module__p-b-0___K85rf`,
	"pB5": `OrderHistoryList-module__p-b-5___dEWCI`,
	"pB10": `OrderHistoryList-module__p-b-10___z0sn8`,
	"pB12": `OrderHistoryList-module__p-b-12___gzuEs`,
	"pB16": `OrderHistoryList-module__p-b-16____mdo2`,
	"pB18": `OrderHistoryList-module__p-b-18___od9Ca`,
	"pB20": `OrderHistoryList-module__p-b-20___F197E`,
	"pB25": `OrderHistoryList-module__p-b-25___ncu3T`,
	"pB30": `OrderHistoryList-module__p-b-30___XFd66`,
	"pB50": `OrderHistoryList-module__p-b-50___yGFPm`,
	"pT0": `OrderHistoryList-module__p-t-0___wa7qU`,
	"pT12": `OrderHistoryList-module__p-t-12___Q0K8L`,
	"pT16": `OrderHistoryList-module__p-t-16___XXB_O`,
	"pT18": `OrderHistoryList-module__p-t-18___J3P9J`,
	"pT20": `OrderHistoryList-module__p-t-20___eiINl`,
	"pT30": `OrderHistoryList-module__p-t-30___CWSXD`,
	"pT40": `OrderHistoryList-module__p-t-40___ttMzU`,
	"pT50": `OrderHistoryList-module__p-t-50___o7piS`,
	"pL20": `OrderHistoryList-module__p-l-20___oltvs`,
	"pL30": `OrderHistoryList-module__p-l-30___IdOIx`,
	"pL40": `OrderHistoryList-module__p-l-40___d3rsh`,
	"pR16": `OrderHistoryList-module__p-r-16___fDKpr`,
	"pR20": `OrderHistoryList-module__p-r-20___BCMFz`,
	"pR30": `OrderHistoryList-module__p-r-30___Z7HZ0`,
	"pR50": `OrderHistoryList-module__p-r-50___TB7nb`,
	"pR60": `OrderHistoryList-module__p-r-60___ENOPN`,
	"mB1": `OrderHistoryList-module__m-b-1___Hz2MG`,
	"mB2": `OrderHistoryList-module__m-b-2___ECsyt`,
	"mB6": `OrderHistoryList-module__m-b-6___qIbx4`,
	"mB8": `OrderHistoryList-module__m-b-8___ebBcx`,
	"mB10": `OrderHistoryList-module__m-b-10___N84G7`,
	"mB14": `OrderHistoryList-module__m-b-14___meWAq`,
	"mB16": `OrderHistoryList-module__m-b-16___v439i`,
	"mB20": `OrderHistoryList-module__m-b-20___nE1x9`,
	"mB22": `OrderHistoryList-module__m-b-22___aRqV8`,
	"mB24": `OrderHistoryList-module__m-b-24___etHmC`,
	"mB30": `OrderHistoryList-module__m-b-30___dcFRc`,
	"mB32": `OrderHistoryList-module__m-b-32___dxCM5`,
	"mB40": `OrderHistoryList-module__m-b-40___ecmV2`,
	"mT2": `OrderHistoryList-module__m-t-2____CNmt`,
	"mT3": `OrderHistoryList-module__m-t-3___VgPQ4`,
	"mT4": `OrderHistoryList-module__m-t-4___ZhokA`,
	"mT5": `OrderHistoryList-module__m-t-5___uucsd`,
	"mT8": `OrderHistoryList-module__m-t-8___T21v8`,
	"mT10": `OrderHistoryList-module__m-t-10___R7cBm`,
	"mT15": `OrderHistoryList-module__m-t-15___VFdN9`,
	"mT16": `OrderHistoryList-module__m-t-16___bT0hb`,
	"mT20": `OrderHistoryList-module__m-t-20___f2DAU`,
	"mT22": `OrderHistoryList-module__m-t-22___KK8hM`,
	"mT30": `OrderHistoryList-module__m-t-30___KWpp9`,
	"mT32": `OrderHistoryList-module__m-t-32___CLhoo`,
	"mLAuto": `OrderHistoryList-module__m-l-auto___sXFuQ`,
	"mL4": `OrderHistoryList-module__m-l-4____p_PQ`,
	"mL5": `OrderHistoryList-module__m-l-5___u3jOM`,
	"mL6": `OrderHistoryList-module__m-l-6___W_cD4`,
	"mL8": `OrderHistoryList-module__m-l-8___PlKvn`,
	"mL10": `OrderHistoryList-module__m-l-10___K_bcS`,
	"mL16": `OrderHistoryList-module__m-l-16___mXLpS`,
	"mL20": `OrderHistoryList-module__m-l-20___Q0zZu`,
	"mL24": `OrderHistoryList-module__m-l-24___DpMNn`,
	"mL30": `OrderHistoryList-module__m-l-30___zH3Vr`,
	"mL35": `OrderHistoryList-module__m-l-35___x4XmZ`,
	"mL40": `OrderHistoryList-module__m-l-40___scQdm`,
	"mR8": `OrderHistoryList-module__m-r-8___KjoaK`,
	"mR10": `OrderHistoryList-module__m-r-10___QMF_1`,
	"mR16": `OrderHistoryList-module__m-r-16___dEBOU`,
	"mR20": `OrderHistoryList-module__m-r-20___MzYEb`,
	"mR24": `OrderHistoryList-module__m-r-24___pWDx1`,
	"mR30": `OrderHistoryList-module__m-r-30____L736`,
	"mR40": `OrderHistoryList-module__m-r-40___j_yxU`,
	"borderR3": `OrderHistoryList-module__border-r-3___VpdwE`,
	"borderR4": `OrderHistoryList-module__border-r-4___XI6q7`,
	"borderR6": `OrderHistoryList-module__border-r-6___WserW`,
	"borderR10": `OrderHistoryList-module__border-r-10___xiYcu`,
	"borderR12": `OrderHistoryList-module__border-r-12___eOY8t`,
	"borderR16": `OrderHistoryList-module__border-r-16___oNMYt`,
	"borderR50": `OrderHistoryList-module__border-r-50___amaVS`,
	"primaryBorder": `OrderHistoryList-module__primary-border___zQxzH`,
	"primaryBorderB": `OrderHistoryList-module__primary-border-b___ujkjC`,
	"primaryBorderT": `OrderHistoryList-module__primary-border-t___jYeck`,
	"primaryBorderL": `OrderHistoryList-module__primary-border-l___wrBz9`,
	"primaryBorderR": `OrderHistoryList-module__primary-border-r___SpFnD`,
	"secondaryBorder": `OrderHistoryList-module__secondary-border___kJ8JO`,
	"secondaryBorderB": `OrderHistoryList-module__secondary-border-b___yodXc`,
	"secondaryBorderT": `OrderHistoryList-module__secondary-border-t___HZI8P`,
	"secondaryBorderL": `OrderHistoryList-module__secondary-border-l___mHpaU`,
	"secondaryBorderR": `OrderHistoryList-module__secondary-border-r___RKRk5`,
	"gap0": `OrderHistoryList-module__gap-0___RTrfs`,
	"gap2": `OrderHistoryList-module__gap-2___pyB2z`,
	"gap4": `OrderHistoryList-module__gap-4___r3b39`,
	"gap5": `OrderHistoryList-module__gap-5___Zgz7K`,
	"gap6": `OrderHistoryList-module__gap-6___fUX1J`,
	"gap8": `OrderHistoryList-module__gap-8___Hg0ia`,
	"gap10": `OrderHistoryList-module__gap-10___FHWlK`,
	"gap12": `OrderHistoryList-module__gap-12___HO8rG`,
	"gap14": `OrderHistoryList-module__gap-14___M7s1r`,
	"gap16": `OrderHistoryList-module__gap-16___JMqHW`,
	"gap18": `OrderHistoryList-module__gap-18___XIZf3`,
	"gap20": `OrderHistoryList-module__gap-20____iQLh`,
	"gap24": `OrderHistoryList-module__gap-24___OG8gK`,
	"gap26": `OrderHistoryList-module__gap-26___BWFEU`,
	"gap30": `OrderHistoryList-module__gap-30___L4fjz`,
	"gap32": `OrderHistoryList-module__gap-32___GES_9`,
	"gap40": `OrderHistoryList-module__gap-40___wCdik`,
	"gap50": `OrderHistoryList-module__gap-50___Gajpe`,
	"flex1": `OrderHistoryList-module__flex-1___fHdye`,
	"flexNone": `OrderHistoryList-module__flex-none___A_bMY`,
	"flexColumn": `OrderHistoryList-module__flex-column___Emb2T`,
	"flexRow": `OrderHistoryList-module__flex-row___D7oca`,
	"verticallyCentered": `OrderHistoryList-module__vertically-centered___NZU_1`,
	"horizontallyCentered": `OrderHistoryList-module__horizontally-centered___V4ReZ`,
	"horizontallyEnd": `OrderHistoryList-module__horizontally-end___PuXQE`,
	"verticallyStart": `OrderHistoryList-module__vertically-start___TSb94`,
	"spaceBetween": `OrderHistoryList-module__space-between___rGgQx`,
	"flexWrap": `OrderHistoryList-module__flex-wrap___Cjn7h`,
	"height100": `OrderHistoryList-module__height-100___STvar`,
	"width50": `OrderHistoryList-module__width-50___HEUMd`,
	"width100": `OrderHistoryList-module__width-100___gzYtm`,
	"cursorPointer": `OrderHistoryList-module__cursor-pointer____xbkO`,
	"cursorNotAllowed": `OrderHistoryList-module__cursor-not-allowed___RwOMu`,
	"absoluteCentered": `OrderHistoryList-module__absolute-centered___oFNup`,
	"absolute": `OrderHistoryList-module__absolute___XiYQ6`,
	"relative": `OrderHistoryList-module__relative___MP641`,
	"fixed": `OrderHistoryList-module__fixed___zQmug`,
	"visible": `OrderHistoryList-module__visible___SU9Y5`,
	"invisible": `OrderHistoryList-module__invisible___mcfGl`,
	"col90": `OrderHistoryList-module__col-90___oDzbr`,
	"colAuto": `OrderHistoryList-module__col-auto___w3Gg9`,
	"medicalTabs": `OrderHistoryList-module__medical-tabs___Dg1cm`,
	"medicalTableNew": `OrderHistoryList-module__medical-table-new____hTcn`,
	"noPagination": `OrderHistoryList-module__no-pagination___ESHp8`,
	"medicalTableEmpty": `OrderHistoryList-module__medical-table-empty___slJsF`,
	"iconBtn": `OrderHistoryList-module__icon-btn___vHA5A`,
	"searchIcon": `OrderHistoryList-module__search-icon___IBQEJ`,
	"disableSelect": `OrderHistoryList-module__disable-select___Pohdo`,
	"breakWord": `OrderHistoryList-module__break-word___eLdSA`,
	"popupClearBtn": `OrderHistoryList-module__popup-clear-btn___xYQ5u`,
	"scrollMB20": `OrderHistoryList-module__scroll-m-b-20___SoB0_`,
	"empty": `OrderHistoryList-module__empty___Ff6Bb`,
	"icon": `OrderHistoryList-module__icon___RiqPO`,
	"text": `OrderHistoryList-module__text___a9jiv`
};
module.exports = ___CSS_LOADER_EXPORT___;
